import React from 'react';

import PropTypes from 'prop-types';

import "bootstrap";

import $ from "jquery";

export default class AddItemFromList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      resized: false
    };

    this.resized = this.resized.bind(this);
  }

  componentDidMount() {
    this._makeDropdownInView();
    this._loadPopover();
    window.addEventListener("resize", this.resized);
  }

  componentDidUpdate() {
    this._makeDropdownInView();
    this._loadPopover();
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.resized);
  }

  resized() {
    this.setState({ resized: true });
  }

  _loadPopover() {
    $('[data-toggle="popover"]').popover({ trigger: 'hover' });
  }

  _makeDropdownInView() {
    if (this._isDropdownInViewport()) {
      $(this._thisRef).find('.dropdown-menu').removeClass('dropdown-menu-right');
    } else {
      $(this._thisRef).find('.dropdown-menu').addClass('dropdown-menu-right');
    }
  }

  _isDropdownInViewport() {
    var leftOffset = this._thisRef.getBoundingClientRect().left;
    var dropdownWidth = $(this._thisRef).find('ul.dropdown-menu').outerWidth();
    var dropdownOffset = leftOffset + dropdownWidth;
    return dropdownOffset <= $(window).width();
  }

  _disabled() {
    return this.props.disabled || this.props.availableItems.length === 0;
  }

  render() {
    var availableItemsList = this._availableItems().map(function(item) {
      return (
        <li className="dropdown"
          key={ item.key }
          onClick={function() {
            this.props.itemCallback(item);
          }.bind(this)}>
          <a>
            { item.friendlyName }
          </a>
        </li>);
    }, this);

    return (
      <div className="js-add-item-from-list-dropdown dropdown d-inline-block" ref={(c) => { this._thisRef = c; }}>
        <div className="multiselect-dropdown-title" data-test-id="add-item-from-list-label">{ this.props.label }</div>
        { this._renderButtonComponents() }
        { this._renderDropdownMenu(availableItemsList) }
      </div>
    );
  }

  _availableItems() {
    if (this.props.shouldSort) {
      return this.props.availableItems.sort((filterA, filterB) => filterA.friendlyName.localeCompare(filterB.friendlyName));
    } else {
      return this.props.availableItems;
    }
  }

  _renderButtonComponents() {
    if (this._disabled()) {
      return (
        <div className="js-disabledWrapper" style={{ cursor: 'not-allowed' }} data-toggle="popover" data-trigger="hover" data-placement="bottom" data-content={ this.props.disabledButtonLabel }>
          { this._renderButton() }
        </div>
      );
    } else {
      return (
        this._renderButton()
      );
    }
  }

  _renderDropdownMenu(availableItemsList) {
    if (availableItemsList.length > 0) {
      return (
        <ul className="dropdown-menu">
          { availableItemsList }
        </ul>
      );
    }
  }

  _renderButton() {
    var styles = this._disabled() ? { pointerEvents: 'none' } : {};

    return (
      <button className="js-dropdown-btn btn btn-primary btn-icon plusButton" style={ styles } disabled={ this._disabled() } type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="true">
        <i className='material-icons'>add</i>
      </button>
    );
  }
}

AddItemFromList.propTypes = {
  availableItems:      PropTypes.arrayOf(
    PropTypes.shape({
      key:          PropTypes.string.isRequired,
      friendlyName: PropTypes.string.isRequired
      // other attributes are optional
    })
  ).isRequired,
  itemCallback:        PropTypes.func.isRequired, // function called when item is clicked from the dropdown menu, the item is the function's argument
  label:               PropTypes.string,
  disabled:            PropTypes.bool,
  disabledButtonLabel: PropTypes.string,
  shouldSort:          PropTypes.bool
};
